import { version } from './app-version'


export const environment = {
  version,
  production: true,
  apiHost: '/api',
  loadingStateChangeDelay: 2000,
  autoCloseConfirmModalDelay: 10000,
  gtmId: 'GTM-MJ5N6VK',
  intercomAppId: 'i2u689d8',
  gtmDebug: false
}
